import {
  PositionOrderBy,
  PositionStatusRest,
  useGetPositions,
} from "~/entity/Positions";
import { useGetLocationData } from "~/hooks/locationData";

import { getPositionDirectorySortableApiKeys } from "./EditorPositionsDirectory/model/tableAdapter";
import { Position } from "./types";
import { transformTableData } from "./utils";

/**
 * Данные справочника должностей. Значения фильтров читаются из URL
 * (открытый фильтр на базе ~/features/filter), даты приходят строками `yyyy-MM-dd`.
 */
export const usePositionsGuideData = (page, count) => {
  const { event, sortField, sortType } = useGetLocationData();
  // Ключи фильтров приходят из URL и не описаны в типе useGetLocationData
  const {
    id,
    code,
    name,
    status,
    DirectionId,
    creationFrom,
    creationTo,
    lastEditFrom,
    lastEditTo,
    showInZd,
    jobDescriptionIsRequired,
  } = useGetLocationData() as Record<string, unknown>;

  const sortableApiKeys = getPositionDirectorySortableApiKeys();
  const orderBy = sortableApiKeys.includes(sortField)
    ? (sortField as PositionOrderBy)
    : undefined;
  const orderDirection =
    orderBy && (sortType === "ASC" || sortType === "DESC")
      ? (sortType.toLowerCase() as "asc" | "desc")
      : undefined;

  const { positions, total, isLoading, refetch } = useGetPositions({
    page,
    count,
    actualOn: event || undefined,
    name: name ? String(name) : undefined,
    code: code ? String(code) : undefined,
    instanceIds: id ? [Number(String(id))] : undefined,
    statuses: status ? [String(status) as PositionStatusRest] : undefined,
    directionId: DirectionId ? Number(String(DirectionId)) : undefined,
    createdAtFrom: creationFrom ? String(creationFrom) : undefined,
    createdAtTo: creationTo ? String(creationTo) : undefined,
    updatedAtFrom: lastEditFrom ? String(lastEditFrom) : undefined,
    updatedAtTo: lastEditTo ? String(lastEditTo) : undefined,
    showInZd: (showInZd ? String(showInZd) : undefined) as
      | "true"
      | "false"
      | undefined,
    jobDescriptionIsRequired: (jobDescriptionIsRequired
      ? String(jobDescriptionIsRequired)
      : undefined) as "true" | "false" | undefined,
    orderBy,
    orderDirection,
  });

  const tableItems = transformTableData(
    positions?.map((position) => ({
      id: String(position.instanceId),
      InstanceId: position.instanceId,
      code: position.code,
      name: position.name,
      nameEn: position.nameEn,
      Direction: position.direction
        ? {
            id: position.direction.id,
            name: position.direction.name,
            status: position.direction.status,
          }
        : null,
      status: position.status,
      createdAt: position.createdAt,
      updatedAt: position.updatedAt,
      RequiredEmail: position.requiredEmail,
      showInZd: position.showInZd,
      jobDescriptionIsRequired: position.jobDescriptionIsRequired,
    })) as unknown as Position[],
  );

  return {
    loading: isLoading,
    refetch,
    tableItems,
    totalRecords: total,
  };
};
